/* eslint-disable jira/filename-case, jira/jira-ssr/no-server-variable */
// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
export const IS_MODERN_SSR: boolean =
	(typeof __SERVER__ !== 'undefined' ? __SERVER__ : false) &&
	process.env.JIRA_SSR_IS_MODERN_SSR === 'true';
